export default "__VITE_ASSET__A9XGcu_T__"